import React from 'react'
import { IonRow } from '@ionic/react'
import { ToggleSegmentButtons } from '../../../../../../components/segmentButtons/toggleSegmentButtons/ToggleSegmentButtons.component'
import { useDispatch, useSelector } from 'react-redux'
import { setBodyView } from '../../store/burns.actions'
import { getBodyViewSelector } from '../../selectors/getBodyViewSelector'
import { ISegmentButton } from '../../../../../../components/segmentButtons/SegmentButtons.component'

const BurnsSegment = () => {
  const dispatch = useDispatch()
  const selectedBodyView = useSelector(getBodyViewSelector)
  const segmentsArr = [
    {
      id: 1,
      name: 'Front',
    },
    {
      id: 2,
      name: 'Back',
    },
  ]

  const handleToggleBodyView = (option: ISegmentButton) => {
    dispatch(setBodyView(option))
  }

  return (
    <IonRow className='p-10 d-flex justify-content-center'>
      <ToggleSegmentButtons
        dataTestId='BurnsToggleButton'
        selected={selectedBodyView}
        segmentsList={segmentsArr}
        onChangeAction={handleToggleBodyView}
      />
    </IonRow>
  )
}

export default BurnsSegment
